export type ExtractPathnameFromSearchReturnType = {
  params: string;
  route: string;
};

export const extractPathnameFromSearch = (search: Record<string, string | string[]>): ExtractPathnameFromSearchReturnType => {
  const params = new URLSearchParams(search as unknown as URLSearchParams);
  let route = params.get('pathname');
  params.delete('pathname');

  if (!route) {
    route = params.get('route');
    params.delete('route');
  }

  return <ExtractPathnameFromSearchReturnType>{
    params: params.toString(),
    route,
  };
};

export const getRoute = (path: string | any[]) => {
  // Remove trailing slash if present
  const trimmedPath = path[path?.length - 1] === '/' ? path?.slice(0, -1) : path;

  // Check for and handle question mark
  if (trimmedPath.includes('?')) {
    return typeof trimmedPath === 'string' ? trimmedPath?.split('?') : [0];
  }
  return trimmedPath;
};
